import { defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["src"]


export default /*#__PURE__*/_defineComponent({
  __name: 'ImageHolder',
  props: {
  imageUrl: String,
  default: null,
  isRounded: {
    type: Boolean,
    default: true,
  },
},
  setup(__props) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (__props.imageUrl)
    ? (_openBlock(), _createElementBlock("img", _mergeProps({ key: 0 }, _ctx.$attrs, {
        src: __props.imageUrl,
        class: ["tw-border-solid tw-border-white tw-w-full tw-h-full tw-object-cover", {
      '!tw-rounded-lg': !__props.isRounded,
      'tw-rounded-full': __props.isRounded,
    }]
      }), null, 16, _hoisted_1))
    : (_openBlock(), _createElementBlock("img", _mergeProps({ key: 1 }, _ctx.$attrs, {
        src: "https://picsum.photos/40",
        class: ["tw-border-solid tw-border-white tw-w-full tw-h-full tw-object-cover", {
      '!tw-rounded-lg': !__props.isRounded,
      'tw-rounded-full': __props.isRounded,
    }]
      }), null, 16))
}
}

})